var map = {
	"./auth.tpl.html": 42234,
	"./deckWrapper.tpl.html": 31078,
	"./endPresentation.tpl.html": 42304,
	"./menuEditor.tpl.html": 48006,
	"./menuPresentations.tpl.html": 58,
	"./menuUser.tpl.html": 19726,
	"./quoteChooser.tpl.html": 76651,
	"./themeChooser.tpl.html": 81393,
	"./welcomeIntro.tpl.html": 31568,
	"./welcomeStep.tpl.html": 56673,
	"static/templates/auth.tpl.html": 42234,
	"static/templates/deckWrapper.tpl.html": 31078,
	"static/templates/endPresentation.tpl.html": 42304,
	"static/templates/menuEditor.tpl.html": 48006,
	"static/templates/menuPresentations.tpl.html": 58,
	"static/templates/menuUser.tpl.html": 19726,
	"static/templates/quoteChooser.tpl.html": 76651,
	"static/templates/themeChooser.tpl.html": 81393,
	"static/templates/welcomeIntro.tpl.html": 31568,
	"static/templates/welcomeStep.tpl.html": 56673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85818;